<div class="page-container">
  <div class="page-title-section">
    <h1><mat-icon>inventory</mat-icon> Estoque (DES)</h1>
    <p class="page-subtitle">Consulte os estoques dos distribuidores exclusivos</p>
  </div>

  <!-- Filters -->
  <div class="filter-section">
    <div class="filter-header">
      <mat-icon>tune</mat-icon>
      Filtros de Pesquisa
    </div>
    <div class="filter-body">
      <form [formGroup]="filterForm">
        <div class="filter-grid cols-4">
        <app-select-form-field
          label="Distribuidor"
          [control]="distributor"
          [options]="distributors"
          [display]="companyDisplayName"
        />
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>CNPJ</mat-label>
          <input matInput type="text" formControlName="document" mask="AA.AAA.AAA/0000-00" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Descrição</mat-label>
          <input matInput type="text" formControlName="productName" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>CAI</mat-label>
          <input matInput type="text" formControlName="productCode" />
        </mat-form-field>
        </div>
      </form>
    </div>
    <div class="filter-footer">
      <div class="filter-footer-left">
        <button mat-flat-button color="accent" class="mic-btn-icon-left" (click)="applyFilter()">
          <mat-icon>search</mat-icon><span>Buscar</span>
        </button>
        <button mat-stroked-button color="primary" class="mic-btn-icon-left" (click)="resetFilter()">
          <mat-icon>refresh</mat-icon><span>Limpar</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-section">
    <mic-table #table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micCellTemplate="let item; name: 'activeCell'">
        @if (item.status === 'A') {
          <mat-icon>check</mat-icon>
        }
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'removedCell'">
        @if (item.deleted) {
          <mat-icon>check</mat-icon>
        }
      </ng-container>
    </mic-table>
  </div>
</div>
